import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import store from "./store";
import VueApexCharts from "vue3-apexcharts";
import { createApp } from "vue";
import { loadFonts } from "./plugins/webfontloader";
import { Amplify } from "aws-amplify";

loadFonts();

Amplify.configure({
  Auth: {
    Cognito: {
      region: "us-east-1",
      userPoolId: "us-east-1_i4PYKx5P1",
      userPoolClientId: "5kd47vi6lrjii7hcsc7s79p7rr",
      signUpVerificationMethod: "code",
      loginWith: {
        email: true,
      },
    },
  },
  API: {
    GraphQL: {
      endpoint:
        "https://jjlnne44enfatk3hvcivnfu3ge.appsync-api.us-east-1.amazonaws.com/graphql",
      region: "us-east-1",
      defaultAuthMode: "userPool",
      logger_level: "DEBUG",
    },
  },
  Storage: {
    S3: {
      bucket: "stichh-medias",
      region: "us-east-1",
      buckets: {
        medias: {
          bucketName: "stichh-medias",
          region: "us-east-1",
          paths: {
            "splayCategory/*": {
              authenticated: ["get", "list", "write", "delete"],
              guest: ["get", "list", "write"],
            },
          },
        },
      },
    },
  },
});

const app = createApp(App);

app.use(router).use(store).use(vuetify).use(VueApexCharts).mount("#app");
